import React from 'react';
import Register from './Register';

const RegisterData = props => {
  return <Register {...props} />;
};

export default RegisterData;
